<script setup lang="ts">
/*
 * Product logo for the top-bar. Markup + sizing mirror the V6 prototype
 * (line ~9255 of `redesign/optimal-hr-prototype-v6.html`): 40px tall,
 * width auto, block + shrink-0 so the nav row can compress without the
 * logo ever rescaling.
 */
import logoUrl from '@/assets/optimalhr-logo.png';
</script>

<template>
  <img
    :src="logoUrl"
    alt="OptimalHR"
    class="block shrink-0 select-none"
    style="height: 40px; width: auto"
  />
</template>
